// extracted by mini-css-extract-plugin
export default {"box":"style_box__cuMwk","box__header":"style_box__header__bCPHS","box__body":"style_box__body__+9y73"};